window.addEventListener('load', function () {
  // Only proceed if Shopify consent is granted and gtag exists
  if (typeof Shopify !== 'undefined' && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed() && typeof gtag === 'function') {
    window.addEventListener('klaviyoForms', function (e) {
      const formEventMap = {
        open: {
          event: 'klaviyo_form_displayed',
          label: 'Welcome Mat Popup Displayed',
          interaction: false,
        },
        embedOpen: {
          event: 'klaviyo_form_displayed',
          label: 'Welcome Mat Embedded Displayed',
          interaction: false,
        },
        submit: {
          event: 'klaviyo_form_submitted',
          label: 'Welcome Mat Popup Form Submit',
          interaction: true,
        },
        close: {
          event: 'klaviyo_form_closed',
          label: 'Welcome Mat Popup Closed',
          interaction: false,
        },
      };

      const mapped = formEventMap[e.detail.type];
      if (mapped) {
        gtag('event', mapped.event, {
          event_category: 'Klaviyo Form Interaction',
          event_label: mapped.label,
          non_interaction: !mapped.interaction,
        });
      }
    });
  }
});
